module.exports = __webpack_public_path__ + "img/gold4.dceeda59.png";